export interface Protocol17025Chart_Interface {
  id:number,
  title:String,
  code:String,
  dsc:String,
  src:String,
  parent:number,
  chart_type:number,
  subdate:String,
  username: String,
  child: Array<Protocol17025Chart_Interface>,
  childVisible:boolean
}

export function Empty_Protocol17025Chart_Interface():Protocol17025Chart_Interface{
  return{
    id:0,
    title:'',
    code:'',
    dsc:'',
    src:'',
    parent:0,
    chart_type:0,
    subdate:'',
    username:'',
    child: [],
    childVisible:true
  }
}
